var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "3 1 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6197_633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 7.02823L14.2266 5.57901L16.9609 5.98917C17.5625 7.02823 17.918 8.17667 17.9727 9.35245L16.0039 11.0751L14.3359 10.3915L13.2422 7.02823ZM11.3008 13.0165L14.1445 10.9657L15.7578 11.6493L16.0039 14.5478C15.3477 15.204 14.6367 15.7235 13.8164 16.079L11.3008 14.8485V13.0165ZM8.23828 5.22354L9.52344 2.81729C10.4805 2.62589 11.4922 2.62589 12.4492 2.81729L13.7344 5.22354L12.7227 6.67276H9.25L8.23828 5.22354ZM16.3594 11.5673L17.9727 10.1728C17.8633 11.5399 17.3984 12.8251 16.5508 13.8915L16.3594 11.5673ZM5.50391 5.30557C6.35156 4.26651 7.44531 3.47354 8.70312 3.03604L7.69141 4.97745L5.50391 5.30557ZM4 9.35245C4.05469 8.17667 4.41016 7.00089 5.01172 5.98917L7.74609 5.57901L8.73047 7.02823L7.63672 10.3642L5.96875 11.0751L4 9.35245ZM5.96875 14.5478L6.21484 11.6493L7.82812 10.9657L10.6719 13.0165V14.8485L8.15625 16.079C7.33594 15.6962 6.59766 15.204 5.96875 14.5478ZM4 10.1728L5.61328 11.5673L5.42188 13.8915C4.60156 12.8251 4.10938 11.5399 4 10.1728ZM8.94922 16.3524L10.9727 15.3681V15.3954L11 15.3681L13.0234 16.3524C12.3672 16.5712 11.6836 16.6532 11 16.6532C10.2891 16.6532 9.60547 16.5712 8.94922 16.3524ZM8.23828 10.5009L9.30469 7.27432H12.668L13.7344 10.5009L11 12.497L8.23828 10.5009ZM16.4688 5.30557C15.6211 4.26651 14.5273 3.47354 13.2695 3.03604L14.2812 4.97745L16.4688 5.30557Z",
    fill: "#FF9F1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6197_633",
    x: 0,
    y: 0.625885,
    width: 21.9727,
    height: 22.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6197_633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6197_633",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default ForwardRef;